import React, { useEffect, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

const TabChangesPopup = ({ isOpen, onClose, title, hrImages, technicalImages, codingImages, mockTestImages, isJobPost }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('hr'); // 'hr' or 'technical' or 'coding'

  useEffect(() => {
   if (hrImages.length > 0) {
    setActiveTab('hr');
   } else if (technicalImages.length > 0) {
    setActiveTab('technical');
   } else if (codingImages.length > 0) {
    setActiveTab('coding');
   } else if (mockTestImages.length > 0) {
    setActiveTab('mockTest');
   }
  }, [hrImages, technicalImages, codingImages, mockTestImages]);

  if (!isOpen) return null;

  const currentImages = activeTab === 'hr' ? hrImages : activeTab === 'technical' ? technicalImages : activeTab === 'coding' ? codingImages : activeTab === 'mockTest' ? mockTestImages : [];

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? currentImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === currentImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const switchToHr = () => {
    setActiveTab('hr');
    setCurrentIndex(0);
  };

  const switchToTechnical = () => {
    setActiveTab('technical');
    setCurrentIndex(0);
  };

  const switchToCoding = () => {
    setActiveTab('coding');
    setCurrentIndex(0);
  };

  const switchToMockTest = () => {
    setActiveTab('mockTest');
    setCurrentIndex(0);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg w-[90%] max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <IoClose size={24} />
          </button>
        </div>

        {/* Tab Buttons */}
        {isJobPost && (
        <div className="flex gap-4 px-4 pt-4">
          {hrImages?.length > 0 && (
            <button
              onClick={switchToHr}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === 'hr'
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              HR Interview ({hrImages.length})
            </button>
          )}
          {technicalImages?.length > 0 && (
            <button
              onClick={switchToTechnical}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === 'technical'
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Technical Interview ({technicalImages.length})
            </button>
          )}
          {codingImages?.length > 0 && (
            <button
              onClick={switchToCoding}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === 'coding'
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Coding Interview ({codingImages.length})
            </button>
          )}
          {mockTestImages?.length > 0 && (
            <button
              onClick={switchToMockTest}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                activeTab === 'mockTest'
                  ? 'bg-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              MCQ Test ({mockTestImages.length})
            </button>
          )}
        </div>
        )}

        {/* Image Container */}
        <div className="relative p-4">
          <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden">
            <img 
              src={currentImages[currentIndex]?.url} 
              alt={currentImages[currentIndex]?.label}
              className="w-full h-full object-contain"
            />
            
            {/* Navigation Buttons */}
            {currentImages.length > 1 && (
              <>
                <button
                  onClick={handlePrevious}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg"
                >
                  <IoIosArrowBack size={24} />
                </button>
                <button
                  onClick={handleNext}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg"
                >
                  <IoIosArrowForward size={24} />
                </button>
              </>
            )}
          </div>

          {/* Image Info */}
          <div className="mt-4 text-center">
            <h3 className="font-medium text-lg">{currentImages[currentIndex]?.label}</h3>
            <p className="text-gray-600">{currentImages[currentIndex]?.description}</p>
            <p className="text-sm text-gray-500 mt-2">
              {currentIndex + 1} of {currentImages.length}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabChangesPopup; 